import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParaDrawerComponent } from './para-drawer.component';
import { StudentBadgeModule } from '../student-badge/student-badge.module';

@NgModule({
	declarations: [ParaDrawerComponent],
	imports: [CommonModule, StudentBadgeModule],
	exports: [ParaDrawerComponent]
})
export class ParaDrawerModule { }
